import React from 'react';
import { useTranslation } from 'react-i18next';
import Dashboard from './Dashboard';
import { PageHeaderCustom } from '../../components';

const Home = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageHeaderCustom title={t('home.title.dashboard')} />
      <Dashboard />
    </>
  );
};

export default Home;
